import React from 'react';
import { TFunction } from 'i18next';
import { AppIconListItem } from './partials/AppIconListItem';
import Hyperlink from '../../../components/atoms/Hyperlink/Hyperlink';
import { TooltipPlacement } from '../../../components/atoms/Tooltip';
import ILink from '../../../types/ILink';
import { Modifier } from '../../../lib/bemUtils/Modifier';
import extendClassName from '../../../lib/bemUtils/bem';
import {
  getItemHelpText,
  getLinkItemIcon,
  getTarget,
  getUrlProtocol,
} from '../../../components/atoms/Hyperlink/Hyperlink.utils';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { ellipsis } from '../../StringUtils';

export type AppIconElement = {
  link: ILink;
  image?: { alt: string; src: string };
};

export type AppIconListProps = { items: AppIconElement[]; modifier?: Modifier<'pal'> };

export function AppIconList({ items, modifier }: AppIconListProps) {
  const { t } = useSonTranslation('phrases');

  return (
    <div className={extendClassName('app-icon-list', modifier)}>
      {/* ul is not empty. If items is empty, this component will not be rendered */}
      <ul className="app-icon-list__list">
        {items?.map((item) => {
          const protocol = getUrlProtocol(item.link.url);

          return (
            <li className="app-icon-list__list-item" key={`${item.link.url}${item.link.name}${item.image?.src}`}>
              <Hyperlink
                to={item.link.url}
                external={item.link.external}
                target={getTarget(item.link.url)}
                className="app-icon-list__list-item-link font-regular-13-13"
                tooltipPlacement={TooltipPlacement.BOTTOM}
                ariaLabel={item.link.name}
                title={item.link.external ? getItemHelpText(protocol, t as TFunction) : undefined}
              >
                {item.image?.src && (
                  <AppIconListItem
                    icon={item.link.external ? getLinkItemIcon(protocol) : undefined}
                    src={item.image.src}
                  />
                )}
                {ellipsis(item.link.name, 28)}
              </Hyperlink>
            </li>
          );
        })}
      </ul>
    </div>

  );
};
